import { Block } from '@components/core-ui/Block';
import { Tag } from '@components/core-ui/Tag';
import { usePageContext } from '@pages/User/NewJobPage/providers/PageProvider';
import React from 'react';
import { Input } from '@components/core-ui/form-elements/Input';
import { Tags } from './styles/Tags';

export const TagsBlock = () => {
  const { form, setFormItemValue, isLoading } = usePageContext();

  const onChange = async (evt: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { value } = evt.target;
    await setFormItemValue('tags', value.split(','));
  };
  const deleteTag = async (tag: string) => {
    await setFormItemValue(
      'tags',
      (form.item?.tags ?? []).filter((t: string) => t !== tag),
    );
  };

  const tagsValue = (form.item?.tags ?? []).join(',');
  const tagsArray = (form.item?.tags ?? []).filter((tag: string) => !!tag);

  return (
    <Block title="Tags" description={<p>Comma separated</p>}>
      <Input
        name="tags"
        label="Add tags..."
        value={tagsValue}
        disabled={isLoading}
        onChange={onChange}
        required={false}
      />
      <Tags>
        {tagsArray.map((tag: string, index: number) => (
          <Tag key={index} onDelete={() => deleteTag(tag)}>
            {tag}
          </Tag>
        ))}
      </Tags>
    </Block>
  );
};
